import { createVNode as l, mergeProps as i } from "vue";
import p from "../node_modules/@pf-ui/pf-icon-svg/es/asn/TopFilled.js";
import m from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return l(m, i(t, {
    icon: p
  }), null);
};
o.displayName = "TopFilled";
o.inheritAttrs = !1;
export {
  o as default
};
